// root of the vue app
<template>
    <router-view />
</template>
<style lang="scss">
@import './App.scss';
</style>
